import React from 'react'
import SessionSelectorButton from '@App/components/CourseRelatedComponents/SessionSelectorButton/SessionSelectorButton'
import { moduleSessions } from '@App/components/CourseRelatedComponents/course-related-components.constants'
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useLocation, Link } from 'react-router-dom'
import { isSessionCompleted } from '@App/components/CourseRelatedComponents/course-related-components.util'

import './session-selector.styl'

function SessionSelector() {
  const { t } = useTranslation()
  const location = useLocation()
  const currentModule = Number(location.pathname.split('/').pop())
  const module = moduleSessions.find(item => item.id === currentModule)
  
  return (
    <div className="session-selector-template">
      <Link to="/learn" className="session-selector__back-btn">{t('Go back')}</Link>
      <div className="session-selector__options">
        <h2>{`${t('Module')} ${module.id}`}</h2>
        <p className="session-selector-template__title">{t(`${module.title}`)}</p>
        <div className="session-selector-template__modules__wrapper">
          {module.sessions.map(session => (
            <SessionSelectorButton
              key={session.id}
              session={session}
              completed={isSessionCompleted(currentModule, session.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default SessionSelector